import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import TooltipMaterialUI from '@material-ui/core/Tooltip';
import infoIcon from '../../assets/images/info.svg';
import styles from './tooltip.module.scss';

const CustomTooltip = ({ className, label, text, value }) => (
  <div className={cn(styles.container, className)}>
    <div>
      {label && <span className={styles.label}>{label}</span>}
      {text && (
        <TooltipMaterialUI placement='top-end' title={text}>
          <img className={styles.icon} src={infoIcon} alt='info' />
        </TooltipMaterialUI>
      )}
    </div>
    {value && <div className={styles.value}>{value}</div>}
  </div>
);

CustomTooltip.propTypes = {
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  text: PropTypes.node,
  value: PropTypes.string,
};

CustomTooltip.defaultProps = {
  className: '',
  label: '',
  text: null,
  value: '',
};

export default CustomTooltip;
